export enum StepStatus {
  Active = "active",
  Complete = "complete",
  Upcoming = "upcoming",
}

export interface StepDetails {
  id: string;
  label: string;
  iconName: string;
  content?: React.ReactNode;
  disableNextButton?: boolean;
  nextButtonLabel?: string;
  hideCancelButton?: boolean;
  cancelButtonLabel?: string;
  hidePrevButton?: boolean;
  prevButtonLabel?: string;
  onNextButtonClick?: () => void;
}

export interface MultiStepModalProps {
  id: string;
  title: string;
  dataCy?: string;
  className?: string;
  steps: StepDetails[];
  onClose?: () => void;
  autoCloseOnLastNextButtonClick?: boolean;
}
